import { getProfiBazaApiClient } from '@services/ProfiBazaApi';
import { FileType } from '@services/src/models';
import { ProfiBazaAPIModels } from '@services/src/profiBazaAPI';

import { SupportedExportType } from '../../shared/paginatedProfiBazaTable/actions/ExportButtons';
import { SieveModel } from '../../shared/paginatedProfiBazaTable/SieveModels';

export const exportActions = (
	exportType: SupportedExportType,
	abortSignal: AbortSignal | undefined
) => {
	switch (exportType) {
		case 'default':
			return (
                sieve: SieveModel,
                allRowsSelected: boolean,
                filter?: any,
				checkedIds?: string[],
				unCheckedIds?: string[],
				fileType?: FileType
			) => {
				return getProfiBazaApiClient().then((api) =>
					api.document.getFileList({
						sieveFilters: sieve.filters,
						sieveSorts: sieve.sorts,
						sievePage: sieve.page,
                        sievePageSize: sieve.pageSize,
                        filter: filter,
						labels: sieve.labels,
						isCheckedAll: allRowsSelected,
						checked: checkedIds,
						unchecked: unCheckedIds,
						fileType: fileType,
						abortSignal,
					})
				);
			};

		default:
			throw new Error('Not supported export type');
	}
};
